import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import { useCustomMutation, useInvalidate } from "@refinedev/core";
import LoadingButton from "@mui/lab/LoadingButton";
import { useTranslation } from "../../../../../hooks/useTranslation";

interface PriceDeleteDialogProps {
  priceId: number;
  open: boolean;
  handleClose: () => void;
}

export const PriceDeleteDialog = (props: PriceDeleteDialogProps) => {
  const { priceId, open, handleClose } = props;

  const { isLoading: deleteLoading, mutate: deleteRule } = useCustomMutation();
  const { translate, translateWithoutPrefix } = useTranslation(
    "pages.shipmentPrices.details.delete"
  );

  const invalidate = useInvalidate();

  const handleDelete = () => {
    deleteRule(
      {
        url: `shipment-prices/${priceId}`,
        method: "delete",
        values: {},
        successNotification: () => {
          return {
            message: translate("successMessage"),
            type: "success",
          };
        },
      },
      {
        onSuccess: () => {
          invalidate({
            resource: "all",
            invalidates: ["all"],
          });

          handleClose();
        },
      }
    );
  };

  return (
    <Dialog open={open} onClose={deleteLoading ? undefined : handleClose}>
      <DialogTitle>{translate("title")}</DialogTitle>
      <DialogContent>
        <DialogContentText>{translate("description")}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={deleteLoading}>
          {translateWithoutPrefix("buttons.cancel")}
        </Button>
        <LoadingButton onClick={handleDelete} autoFocus loading={deleteLoading}>
          {translateWithoutPrefix("buttons.delete")}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
